import request from '../httpClient';

export const createMailingList = (
  address: string,
  accessLevel: string,
  botIncluded?: boolean,
  name?: string,
  description?: string
) => request.post('/emails/mailing_list', {address, accessLevel, botIncluded, name, description});



// WEBPACK FOOTER //
// ./src/services/api/mailingList.ts